import React from 'react'

import TablePagination from '@mui/material/TablePagination'
import Container from './styles'

export default ({ ...rest }) => {
  return (
    <Container>
      <TablePagination {...rest} />
    </Container>
  )
}
